import React, { useEffect, useState } from 'react';
import './LecturerComponent.css';
import HeaderComponent, { HeaderWithoutLogin } from '../Header/HeaderComponent';
import FooterComponent from '../Footer/FooterComponent';
import { ModalDoctors } from '../Modal/ModalComponent';
import { getEventActually } from '../../services/EventServices';

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    setIsLoggedIn(!!token); // Sets isLoggedIn to true if token exists, otherwise false
  }, []);

  return isLoggedIn ? <HeaderComponent /> : <HeaderWithoutLogin />;
}

const LecturerComponent = () => {
  const [openModal, setOpenModal] = useState(false);
  const [pictureDoctor, setPictureDoctor] = useState(null);
  const [flagDoctor, setFlagDoctor] = useState(null);
  const [nameDoctor, setNameDoctor] = useState(null);
  const [professionDoctor, setProfessionDoctor] = useState(null);
  const [descriptionDoctor, setDescriptionDoctor] = useState(null);
  const [dataLectures, setDataLectures] = useState([]);

  const openModalHandler = (name, flag, picture, profession, description) => {
    setOpenModal(true);
    setNameDoctor(name);
    setFlagDoctor(flag);
    setProfessionDoctor(profession);
    setPictureDoctor(picture);
    setDescriptionDoctor(description);
  };

  const closeModalHandler = () => {
    setOpenModal(false);
    setNameDoctor(null);
    setFlagDoctor(null);
    setProfessionDoctor(null);
    setPictureDoctor(null);
    setDescriptionDoctor(null);
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await getEventActually();

        setDataLectures(response.speakers);
        console.log(dataLectures);
      }catch(error) {
        throw new Error(error);
      }
    }

    getData();
  }, []);

  const arrayDoctors = [
    {
      "name": "Dr. Mauricio Pérez de la Puente",
      "flag": "/Bandera-Ecuador.png",
      "picture": "/Doc-Mauricio-Perez-redonded.png",
      "pictureBanner": "/Doc-Mauricio-Perez-description.png",
      "description": "Médico Endocrinólogo.\n Presidente de la Sociedad de Endocrinología - Capítulo Pichincha.\n Máster en Salud Pública con énfasis en Epidemiología."
    },
    {
      "name": "Dr. Jorge Luis Salazar",
      "flag": "/Bandera-Ecuador.png",
      "picture": "/Doc._Jorge_Salazar_redonded.png",
      "pictureBanner": "./Doc._Jorge_Salazar-description.png",
      "description": "Doctor en Medicina y Cirugía por la Universidad Central del Ecuador.\n Especialidad en Medicina Interna y Endocrinología por la Universidad de Buenos Aires.\n Jefe del Servicio de Endocrinología en el Hospital de Especialidades Eugenio Espejo."
    },
    {
      "name": "Dra. Magaly Fiorella Flores Fernández",
      "flag": "/bandera_peru.png",
      "picture": "/Dra._Magaly_Flores_redonded.png",
      "pictureBanner": "./Dra.-Magaly-Flores-description.png",
      "description": "Médico Endocrinóloga UNMSM.\n Magíster en Docencia e Investigación en Salud, Gestión Pública UNMSM.\n Staff Endocrinología - Clínica Delgado AUNA."
    },
    {
      "name": "Dr. Edwin Acho Carranza",
      "flag": "/Bandera-Ecuador.png",
      "picture": "/Doc_Edwin Acho_redonded.png",
      "pictureBanner": "/Doc._Edwin_description.png",
      "description": "Endocrinólogo por la UNFV.\n Jefe de endocrinología de adultos del Hospital San Bartolomé.\n Docente de posgrado de la UNMSM y de pregrado de la Universidad Peruana Unión."
    },
  ];

  return (
    <>
      <div className="container-innovador flex flex-col min-h-screen">
        <Header />

        <div className="flex-grow">
          <p className="text-center text-2xl text-[#F0A727] mt-4">NUESTROS</p>
          <h1 className="font-bold text-4xl text-center text-[#0055D1]">EXPERTOS</h1>

          <div className="max-w-6xl mx-auto p-4">
            {/* Móvil: Una columna */}
            <div className="sm:hidden space-y-12">
              {dataLectures?.map((data, index) => (
                <div key={index} className="flex flex-col items-center">
                  <div className="relative" onClick={() => openModalHandler(data.name, data.flag, data.picture_description, data.profession, data.description)}>
                    <img src={data.picture} className="w-[200px] h-[200px]" alt="doctor" />
                    <img src={data.flag} className="w-10 h-10 mt-4 ml-2 absolute top-0 left-0 transform -translate-x-1/4 -translate-y-1/4" alt="flag" />
                  </div>
                  <p className="text-center mt-4 font-bold text-lg text-[#011965]">{data.name}</p>
                  <span className="text-center text-sm text-[#011965]">{data.profession}</span>
                  <ul className="text-xs text-start text-[#011965] mt-2">
                    {data.description.split(',').map((line, i) => (
                      <li key={i} className="list-disc list-inside">{line}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            {/* Tablet: Zigzag horizontal */}
            <div className="hidden sm:block lg:hidden">
              <div className="flex flex-wrap justify-between mt-10">
                {dataLectures?.map((data, index) => (
                  <div key={index} className={`w-[48%] ${index % 2 !== 0 ? 'mt-32' : '-mt-16'} mb-16`}>
                    <div className="flex flex-col items-center">
                      <div className="relative" onClick={() => openModalHandler(data.name, data.flag, data.picture_description, data.profession, data.description)}>
                        <img src={data.picture} className="w-[200px] h-[200px]" alt="doctor" />
                        <img src={data.flag} className="w-10 h-10 mt-4 ml-2 absolute top-0 left-0 transform -translate-x-1/4 -translate-y-1/4" alt="flag" />
                      </div>
                      <p className="text-center mt-6 font-bold text-xl text-[#011965]">{data.name}</p>
                      <span className="text-center text-lg text-[#011965]">{data.profession}</span>
                      <ul className="text-xs text-start text-[#011965] mt-2">
                        {data.description.split(',').map((line, i) => (
                          <li key={i} className="list-disc list-inside">{line}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Desktop: Zigzag vertical */}
            <div className="hidden lg:block">
              <div className="flex justify-between items-center h-[600px] relative">
                {dataLectures?.map((data, index) => (
                  <div key={index} className={`w-1/4 ${index % 2 === 0 ? '-mt-48' : 'mt-48'}`}>
                    <div className="flex flex-col items-center">
                      <div className="relative" onClick={() => openModalHandler(data.name, data.flag, data.picture_description, data.profession, data.description)}>
                        <img src={data.picture} className="w-[200px] h-[200px]" alt="doctor" />
                        <img src={data.flag} className="w-10 h-10 mt-4 ml-2 absolute top-0 left-0 transform -translate-x-1/4 -translate-y-1/4" alt="flag" />
                      </div>
                      <p className="text-center mt-6 font-bold text-md text-[#011965]">{data.name}</p>
                      <span className="text-center text-md text-[#011965]">{data.profession}</span>
                      <ul className="text-xs text-start text-[#011965] mt-2">
                        {data.description.split(',').map((line, i) => (
                          <li key={i} className="list-disc list-inside">{line}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer siempre pegado abajo */}
        <FooterComponent />
      </div>
      <ModalDoctors showModal={openModal} flagDoctor={flagDoctor} nameDoctor={nameDoctor} pictureDoctor={pictureDoctor} profession={professionDoctor} description={descriptionDoctor} closeModal={closeModalHandler} />
    </>
  );
}

export default LecturerComponent;
